import { useSyncExternalStore } from "react";

// The single 900px query for the whole app. A second declaration is a bug (7.1).
const MOBILE_QUERY = "(max-width: 900px)";

function subscribe(callback: () => void): () => void {
  const mql = window.matchMedia(MOBILE_QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

export function useBreakpoint(): { isMobile: boolean } {
  const isMobile = useSyncExternalStore(
    subscribe,
    () => window.matchMedia(MOBILE_QUERY).matches,
    () => false,
  );
  return { isMobile };
}
